import { ReactNode } from "react";
import AuthHeader from "@/components/common/AuthHeader";

interface AuthLayoutProps {
  children: ReactNode;
  headerBottomComponent?: ReactNode;
}

const AuthLayout = ({ children, headerBottomComponent }: AuthLayoutProps) => {
  return (
    <div className="flex min-h-screen flex-col">
      <AuthHeader bottomComponent={headerBottomComponent} />
      <main className="flex-1 bg-[#F7F5F2] pt-[80px]">
        {children}
      </main>
    </div>
  );
};

export default AuthLayout;